module.exports = __webpack_public_path__ + "9cc85a8bb5330f343851972eb8f74233.svg";